import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TyStore {
    _id: string;
    name: any;
    type: string;
    logo?: string;
}

interface DashboardState {
    storeId: string | null;
    store: TyStore | null;
    setStore: (storeId: string, store: TyStore) => void;
    clearStore: () => void;
}

const useDashboardStore = create<DashboardState>()(
    persist(
        (set) => ({
            storeId: null,
            store: null,
            setStore: (storeId, store) => set({ storeId, store }),
            clearStore: () => set({ storeId: null, store: null }),
        }),
        { name: "dashboard" }
    )
);

export default useDashboardStore;
